/* eslint-disable */

import XLSX from 'xlsx'

export const uuid = () => { // 生产uuid
  let s = []
  let hexDigits = '0123456789abcdef'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'
  let uuid = s.join('')
  return uuid
}

export const system = () => { // 判断并返回系统
  var u = navigator.userAgent
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  // var isWx = u.indexOf('micromessenger') > -1 // wexin
  var system
  // if (isWx) {
  //   system = 'weixin'
  // } else
  if (isAndroid) {
    system = 'android'
  } else if (isIOS) {
    system = 'ios'
  }
  return system
}

export const cookie = { // 关于cookie的相关设置
  set: function (name, value, days) {
    let exp = new Date()
    exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000)
    document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString() + ';path=/'
  },
  get: function (name) {
    var arr
    var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    arr = document.cookie.match(reg)
    if (arr) {
      return unescape(arr[2])
    } else {
      return null
    }
  },
  delete: function (name) {
    var exp = new Date()
    exp.setTime(exp.getTime() - 1)
    var cval = this.get(name)
    if (cval !== null) {
      document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
    }
  }
}

export const getQuery = () => {
  let url = window.location.search
  let theRequest = {}
  if (url.indexOf('?') !== -1) {
    let str = url.substr(1)
    var strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  return theRequest
}

export const isMobileNo = (str) => {
  return str.match(/^((13[0-9])|(14[0-9])|(15[0-3,5-9])|(16[6])|(17[0,1,3,5-8])|(18[0-9])|(19[8,9]))\d{8}$/)
}

export const isEmail = (str) => {
  return str.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
}

export const formatDate = (fmt, date) => { // 时间格式化
  date = new Date(date)
  let o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  }
  return fmt
}

export const sessionStorage = {
  set: function (name, val) {
    if (val instanceof Object) {
      val = JSON.stringify(val)
    }
    window.sessionStorage.setItem(name, val)
  },

  get: function (key) {
    let val = window.sessionStorage.getItem(key)
    if (val) {
      return val
    } else {
      return null
    }
  },

  delete: function (key) {
    window.sessionStorage.removeItem(key)
  },

  clear: function () {
    window.sessionStorage.clear()
  }
}

export const localStorage = {
  set: function (key, val) {
    if (val instanceof Object) {
      val = JSON.stringify(val)
    }
    window.localStorage.setItem(key, val)
  },
  get: function (key) {
    let val = window.localStorage.getItem(key)
    if (val) {
      return val
    } else {
      return null
    }
  },
  delete: function (key) {
    window.localStorage.removeItem(key)
  },
  clear: function () {
    window.localStorage.clear()
  }
}

export const countProperties = (o) => {
  let count = 0
  for (let property in o) {
    if (Object.prototype.hasOwnProperty.call(o, property)) {
      count++
    }
  }
  return count
}

export function find(list, f) {
  return list.filter(f)[0]
}

export const deepCopy = (obj, cache) => {
  if (cache === void 0) cache = []

  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  var hit = find(cache, function (c) {
    return c.original === obj
  })
  if (hit) {
    return hit.copy
  }

  var copy = Array.isArray(obj) ? [] : {}
  cache.push({
    original: obj,
    copy: copy
  })

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache)
  })

  return copy
}

export const isArr = (obj) => {
  return obj.__proto__ === Array.prototype
}

export const scrollTo = (y) => {
  window.scrollTo({
    top: y,
    behavior: 'smooth'
  })
}

export const memoize = (fn) => {
  let cache = {}
  return function () {
    let key = JSON.stringify(arguments)
    let value = cache[key]
    if (!value) {
      value = [fn.apply(this, arguments)]
      cache[key] = value
    }
    return value[0]
  }
}

/* options的默认值
 *  options.leading = true; 表示首次调用返回值方法时，会马上调用func；否则仅会记录当前时刻，当第二次调用的时间间隔超过wait时，才调用func。
 *
 *  options.trailing = true;
 *  表示当调用方法时，未到达wait指定的时间间隔，则启动计时器延迟调用func函数，若后续在既未达到wait指定的时间间隔和func函数又未被调用的情况下调用返回值方法，则被调用请求将被丢弃。
 */
export const throttle = (func, wait, options) => {
  let context = undefined
  let args = undefined
  let result = undefined
  var timeout = null
  var previous = 0
  if (!options) {
    options = {}
  }

  const later = function () {
    previous = options.leading === false ? 0 : Date.parse(new Date())
    timeout = null
    result = func.apply(context, args)
    if (!timeout) {
      context = args = null
    }
  }

  return function () {
    let now = Date.parse(new Date())

    if (!previous && options.leading === false) {
      previous = now
    }

    // 计算剩余时间
    let remaining = wait - (now - previous)
    context = this
    args = arguments

    // 当到达wait指定的时间间隔，则调用func函数
    if (remaining <= 0 || remaining > wait) {
      // 由于setTimeout存在最小时间精度问题，因此会存在到达wait的时间间隔，但之前设置的setTimeout操作还没被执行，因此为保险起见，这里先清理setTimeout操作
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      result = func.apply(context, args)

      if (!timeout) {
        context = args = null
      }

    } else if (!timeout && options.trailing !== false) {
      // options.trailing=true时，延时执行func函数
      timeout = setTimeout(later, remaining)
    }
    return result
  }
}

export const debounce = (func, wait, immediate) => {
  // immediate默认为false
  let timeout = null
  let args = undefined
  let context = undefined
  let timestamp = undefined
  let result = undefined

  const later = function () {
    // 当wait指定的时间间隔期间多次调用_.debounce返回的函数，则会不断更新timestamp的值，导致last < wait && last >= 0一直为true，从而不断启动新的计时器延时执行func
    let last = Date.parse(new Date()) - timestamp

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null

      if (!immediate) {
        result = func.apply(context, args)

        if (!timeout) {
          context = args = null
        }
      }
    }
  }

  return function () {
    context = this
    args = arguments
    timestamp = Date.parse(new Date())

    // 第一次调用该方法时，且immediate为true，则调用func函数
    var callNow = immediate && !timeout

    // 在wait指定的时间间隔内首次调用该方法，则启动计时器定时调用func函数
    if (!timeout) {
      timeout = setTimeout(later, wait)
    }

    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export const convertBase64UrlToBlob = (urlData) => {
  let arr = urlData.split(','), mime = arr[0].match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

export const blobToFile = (theBlob, fileName) => {
  theBlob.lastModifiedDate = new Date()
  theBlob.name = fileName
  return theBlob
}

export const isMobile = () => {
  return (/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i).test(window.navigator.userAgent)
}
export const toMoney = (num, n) => {
  if (num) {
    n = n > 0 && n <= 20 ? n : 2
    num = parseFloat((num + '').replace(/[^\d\.-]/g, '')).toFixed(n) + ''
    var l = num.split('.')[0].split('').reverse(), r = num.split('.')[1]
    let t = ''
    for (let i = 0; i < l.length; i++) {
      t += l[i] + ((i + 1) % 3 === 0 && (i + 1) !== l.length ? ',' : '')
    }
    return t.split('').reverse().join('') + '.' + r
  } else {
    return 0
  }
}
/*金额小写转大写*/
export const digitUppercase = (currencyDigits = 0) => {
  // Constants:
  var MAXIMUM_NUMBER = 999999999999999999999.99;
  // Predefine the radix characters and currency symbols for output:
  var CN_ZERO = "零";
  var CN_ONE = "壹";
  var CN_TWO = "贰";
  var CN_THREE = "叁";
  var CN_FOUR = "肆";
  var CN_FIVE = "伍";
  var CN_SIX = "陆";
  var CN_SEVEN = "柒";
  var CN_EIGHT = "捌";
  var CN_NINE = "玖";
  var CN_TEN = "拾";
  var CN_HUNDRED = "佰";
  var CN_THOUSAND = "仟";
  var CN_TEN_THOUSAND = "万";
  var CN_HUNDRED_MILLION = "亿";
  var CN_SYMBOL = "";
  var CN_DOLLAR = "元";
  var CN_TEN_CENT = "角";
  var CN_CENT = "分";
  var CN_INTEGER = "整";
  let full;
  // Variables:
  var integral;    // Represent integral part of digit number.
  var decimal;    // Represent decimal part of digit number.
  var outputCharacters;    // The output result.
  var parts;
  var digits, radices, bigRadices, decimals;
  var zeroCount;
  var i, p, d, ds;
  var quotient, modulus;
  if (/^\d+.00$/.test(`${currencyDigits}`)) {
    full = true
  }
  // Validate input string:
  currencyDigits = currencyDigits.toString();
  if (currencyDigits == "") {
    console.log("不能为空 请输入数字金额!如：123.23");
    return "";
  }
  if (currencyDigits.match(/[^,.\d]/) != null) {
    console.log("输入字符串中的字符无效!");
    return "";
  }
  if ((currencyDigits).match(/^((\d{1,3}(,\d{3})*(.((\d{3},)*\d{1,3}))?)|(\d+(.\d+)?))$/) == null) {
    console.log("请输入正确的数字金额!");
    return "";
  }

  // Normalize the format of input digits:
  currencyDigits = currencyDigits.replace(/,/g, "");    // Remove comma delimiters.
  currencyDigits = currencyDigits.replace(/^0+/, "");    // Trim zeros at the beginning.
  // Assert the number is not greater than the maximum number.
  if (Number(currencyDigits) > MAXIMUM_NUMBER) {
    console.log("Too large a number to convert!");
    return "";
  }

  // Process the coversion from currency digits to characters:
  // Separate integral and decimal parts before processing coversion:
  parts = currencyDigits.split(".");
  if (parts.length > 1) {
    integral = parts[0];
    decimal = parts[1];
    // Cut down redundant decimal digits that are after the second.
    decimal = decimal.substr(0, 2);
  }
  else {
    integral = parts[0];
    decimal = "";
  }
  // Prepare the characters corresponding to the digits:
  digits = new Array(CN_ZERO, CN_ONE, CN_TWO, CN_THREE, CN_FOUR, CN_FIVE, CN_SIX, CN_SEVEN, CN_EIGHT, CN_NINE);
  radices = new Array("", CN_TEN, CN_HUNDRED, CN_THOUSAND);
  bigRadices = new Array("", CN_TEN_THOUSAND, CN_HUNDRED_MILLION);
  decimals = new Array(CN_TEN_CENT, CN_CENT);
  // Start processing:
  outputCharacters = "";
  // Process integral part if it is larger than 0:
  if (Number(integral) > 0) {
    zeroCount = 0;
    for (i = 0; i < integral.length; i++) {
      p = integral.length - i - 1;
      d = integral.substr(i, 1);
      quotient = p / 4;
      modulus = p % 4;
      if (d == "0") {
        zeroCount++;
      }
      else {
        if (zeroCount > 0) {
          outputCharacters += digits[0];
        }
        zeroCount = 0;
        outputCharacters += digits[Number(d)] + radices[modulus];
      }
      if (modulus == 0 && zeroCount < 4) {
        outputCharacters += bigRadices[quotient];
      }
    }
    outputCharacters += CN_DOLLAR;
  }
  // Process decimal part if there is:
  if (decimal != "") {
    for (i = 0; i < decimal.length; i++) {
      d = decimal.substr(i, 1);
      ds = decimal.substr(-1, 1);
      if (d == 0) {
        if (ds == 0) {
          outputCharacters += "";
        }
        else {
          outputCharacters += digits[Number(d)];
        }
      }
      else {

        outputCharacters += digits[Number(d)] + decimals[i];

      }
    }
  }
  // Confirm and return the final output string:
  if (outputCharacters == "") {
    outputCharacters = CN_ZERO + CN_DOLLAR;
  }
  if (decimal == "" || full) {
    outputCharacters += CN_INTEGER;
  }
  outputCharacters = CN_SYMBOL + outputCharacters;
  return outputCharacters;
}


export const onCount = {
  /*
    说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
    调用：add(arg1,arg2)
    返回值：arg1加上arg2的精确结果
  */
  add: function (arg1, arg2) {
    var r1, r2, m
    try {
      r1 = arg1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    return (arg1 * m + arg2 * m) / m
  },
  /*
    说明：javascript的减法结果会有误差，在两个浮点数相减的时候会比较明显。这个函数返回较为精确的减法结果。
    调用：sub(arg1,arg2)
    返回值：arg1减去arg2的精确结果
  */
  sub: function (arg1, arg2) {
    var r1, r2, m, n
    try {
      r1 = arg1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    //last modify by deeka
    //动态控制精度长度
    n = (r1 >= r2) ? r1 : r2
    return ((arg1 * m - arg2 * m) / m).toFixed(n)
  },
  /*
    说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
    调用：mul(arg1,arg2)
    返回值：arg1乘以arg2的精确结果
  */
  mul: function (arg1, arg2) {
    var m = 0, s1 = arg1.toString(), s2 = arg2.toString()
    try {
      m += s1.split('.')[1].length
    } catch (e) {
    }
    try {
      m += s2.split('.')[1].length
    } catch (e) {
    }
    return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)

  },
  /*
    说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
    调用：div(arg1,arg2)
    返回值：arg1除以arg2的精确结果
  */
  div: function (arg1, arg2) {
    var t1 = 0, t2 = 0, r1, r2
    try {
      t1 = arg1.toString().split('.')[1].length
    } catch (e) {
    }
    try {
      t2 = arg2.toString().split('.')[1].length
    } catch (e) {
    }
    r1 = Number(arg1.toString().replace('.', ''))
    r2 = Number(arg2.toString().replace('.', ''))
    return (r1 / r2) * Math.pow(10, t2 - t1)
  }
}

export const download = (options) => {
  const uid = (new Date()).getTime()
  const {
    url,
    blob,
    title = uid
  } = options
  const a = document.createElement('a')
  a.style.display = 'none'
  a.download = title
  if (blob) {
    let newBlob = new Blob([blob])
    const blobUrl = window.URL.createObjectURL(newBlob)
    a.href = blobUrl
    a.click()
  } else if (url) {
    a.href = url
    a.click()
  }
}

export const delInArr = (arr, index) => {
  const newArr = deepCopy(arr)
  newArr.splice(index, 1)
  return newArr
}

export const addToArr = (arr, index, item) => {
  const newArr = deepCopy(arr)
  newArr.splice(index, 0, item)
  return newArr
}

export const hasOwnProperty = (obj, key) => {
  if (obj && obj.hasOwnProperty(key)) {
    return true
  }
  return false
}

// 嵌套对象判断
export const isContainObj = (obj, needle, keyInobj) => {
  for (let i in obj) {
    if (obj[i][keyInobj] === needle) return true
  }
  return false
}

export const sortByKey = (arr, key, type = 'asc') => {
  let newArr = deepCopy(arr)
  if (type === 'asc') {
    newArr.sort((a, b) => {
      if (a[key] < b[key]) {
        return -1
      } else if (a[key] > b[key]) {
        return 1
      } else {
        return 0
      }
    })
  } else {
    newArr.sort((a, b) => {
      if (a[key] > b[key]) {
        return -1
      } else if (a[key] < b[key]) {
        return 1
      } else {
        return 0
      }
    })
  }
  return newArr
}

export const isObject = (val) => {
  return val !== null && typeof val === 'object' && Array.isArray(val) === false
}

//isLength：检查 value 是否为有效的类数组长度
export const isLength = (value) => {
  return typeof value === 'number' && value > -1 && value % 1 === 0 && value <= Number.MAX_SAFE_INTEGER
}

//isFunction：检查 value 是不是函数
export const isFunction = (value) => {
  return Object.prototype.toString.call(value) === '[object Function]'
}

//isArrayLike：检查 value 是否是类数组
export const isArrayLike = (value) => {
  return value != null && isLength(value.length) && !isFunction(value)
}

//isPlainObject：判断数据是不是Object类型的数据
export const isPlainObject = (obj) => {
  return Object.prototype.toString.call(obj) === '[object Object]'
}

// isEmpty：检查 value 是否为空
export const isEmpty = (value) => {
  if (value === null) {
    return true
  }
  if (value === undefined) {
    return true
  }
  if (isArrayLike(value)) {
    return !value.length
  } else if (isPlainObject(value)) {
    for (let key in value) {
      if (hasOwnProperty.call(value, key)) {
        return false
      }
    }
  }
  return false
}

//处理数组数量
export const dealArrGroup = (array, subGroupLength) => {
  var index = 0
  var newArray = []
  while (index < array.length) {
    newArray.push(array.slice(index, index += subGroupLength))
  }
  return newArray
}

export const ConvertNumber = (number, count = 2, isSavePoint = false) => {
  if (number === undefined || number === null || number === '') {
    return number
  }
  if (typeof number == 'string' && number.includes(',')) {
    return number
  }
  number = +number
  if (!isNaN(number)) {
    if (`${number}`.includes('.')) {
      let _inter = `${number}`.split('.')[0]
      let _point = '0.' + `${number}`.split('.')[1]
      if (!isSavePoint) {
        _point = +_point
        _point = _point.toFixed(count)
        _point = '.' + `${_point}`.split('.')[1]
      }
      number = _inter.replace(/\B(?=(\d{3})+\b)/g, ",") + _point
    } else {
      number = number.toFixed(count).replace(/\B(?=(\d{3})(?=.[0-9])+\b)/g, ",")
    }
  }
  return number
}
export const ParseNumber = (data, parsenumber = true) => {
    if (typeof data == 'string'  ) {
      if(data.includes(',')){
        data = `${data}`.replace(/\,/g, '');
      }
     if(data.includes('%')){
      data = `${data}`.replace(/\%/g, '');
      data/=100;
     }
    }
    if (parsenumber &&data&& typeof data != 'number') {
      data = +data;
    }
    return data;
}
export const ConvertPercent = (number, count = 2, removal = true) => {
  if (number === undefined) {
    return number
  }
  if (typeof number != 'string') {
    number = `${number}`
  }
  if (number.includes('%')) {
    return number
  }
  if (number.includes(',')) {
    let aValues = number.split(',')
    aValues = aValues.map((item) => {
      if (!isNaN(item)) {
        return `${(item * 100).toFixed(count)}%`
      }
    })
    if (removal) {
      aValues = [...new Set(aValues)]
    }
    number = aValues.join(',')
  } else {
    number = `${(number * 100).toFixed(count)}%`
  }
  return number
}
/*导入excel*/
export const readWorkbookFromLocalFile = (file, callback) => {
  var reader = new FileReader()
  reader.onload = function (e) {
    var data = e.target.result
    var workbook = XLSX.read(data, { type: 'binary' })
    if (callback) callback(workbook)
  }
  reader.readAsBinaryString(file)
}
/*获取表格*/
export const readWorkbook = (workbook) => {
  var sheetNames = workbook.SheetNames // 工作表名称集合
  var worksheet = workbook.Sheets[sheetNames[0]] // 这里只读取第一张sheet
  var csv = XLSX.utils.sheet_to_json(worksheet)
  return csv
  // document.getElementById('result').innerHTML = csv2table(csv);
}

export function removeByValue(arr, attr, value) { //数组，属性，属性值
  let newarr = deepCopy(arr)
  let index = 0
  for (let i in newarr) {
    if (newarr[i][attr] === value) {
      index = i
      break
    }
  }
  return newarr.splice(index, 1)
}

export const cutImageBase64 = (file,id,wid,quality,callback=()=>{}) => {
  var URL = window.URL || window.webkitURL
  var blob = URL.createObjectURL(file)
  var base64
  var img = new Image()
  img.src = blob
  img.onload = function() {
    var that = this
    //生成比例
    var w = that.width,
    h = that.height,
    scale = w / h
    w = wid || w
    h = w / scale
    //生成canvas
    var canvas = document.createElement('canvas')
    var ctx = canvas.getContext('2d')
    canvas.setAttribute('width',w)
    canvas.setAttribute('height',h)
    ctx.drawImage(that, 0, 0, w, h)
    // 生成base64            
    base64 = canvas.toDataURL('image/jpeg', quality || 0.8)
    callback(base64)
  }
}
export default {
  uuid,
  cookie,
  getQuery,
  isMobileNo,
  isEmail,
  formatDate,
  sessionStorage,
  localStorage,
  countProperties,
  find,
  deepCopy,
  isArr,
  scrollTo,
  memoize,
  throttle,
  debounce,
  convertBase64UrlToBlob,
  isMobile,
  toMoney,
  digitUppercase,
  onCount,
  download,
  delInArr,
  hasOwnProperty,
  isContainObj,
  sortByKey,
  isObject,
  isLength,
  isFunction,
  isArrayLike,
  isPlainObject,
  isEmpty,
  dealArrGroup,
  ConvertNumber,
  ParseNumber,
  ConvertPercent,
  removeByValue,
  addToArr,
  cutImageBase64,
  system
}
